import { Controller } from '@hotwired/stimulus'

export default class AutoSubmitFormController extends Controller {
  submit() {
    this.element.form.requestSubmit();
  }

  submitWithDebounce() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.element.form.requestSubmit();
    }, 300);
  }
}
